<div class="w-full p-2 flex justify-center">
  <img src="assets/icons/powered_by_reite.svg" alt="Powered by Reite" class="h-auto max-h-8 w-1/2 object-contain">
</div>
